import ForgotPassword from 'pages/ForgotPassword';
import SetPassword from 'pages/SetPassword';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { PagesEnum } from '../../utils/constants';
import LoginPageResolver from '../../utils/reslover';

const PageRenderer = () => {
  const location = useLocation();
  const { LoginPageToRender } = LoginPageResolver();
  const { pathname } = location;
  switch (pathname) {
    case PagesEnum.FORGOT_PASSWORD:
      return <ForgotPassword />;
    case PagesEnum.SET_PASSWORD:
      return <SetPassword />;
    default:
      return <LoginPageToRender />;
  }
};

export default PageRenderer;
